"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MarginOrderEstimates = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _APLabelWithText = _interopRequireDefault(require("../../common/APLabelWithText"));
var _useMaxAmount = require("./useMaxAmount");
var _useBorrowingAmount = require("./useBorrowingAmount");
var _useHourlyInterest = require("./useHourlyInterest");
var _reactRedux = require("react-redux");
var _orderEntrySelector = require("../../../redux/selectors/orderEntrySelector");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var MarginOrderEstimates = exports.MarginOrderEstimates = /*#__PURE__*/(0, _react.memo)(function (_ref) {
  var baseClass = _ref.baseClass,
    formName = _ref.formName;
  var _useTranslation = (0, _reactI18next.useTranslation)('margin'),
    t = _useTranslation.t;
  var maxAmount = (0, _useMaxAmount.useMaxAmount)();
  var borrowingAmount = (0, _useBorrowingAmount.useBorrowingAmount)(formName);
  var hourlyInterest = (0, _useHourlyInterest.useHourlyInterest)(formName);
  var isBuy = (0, _reactRedux.useSelector)(function (state) {
    return (0, _orderEntrySelector.selectIsBuyForm)(state, {
      formName: formName
    });
  });
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_APLabelWithText["default"], {
    label: isBuy ? t('Max Buy Amount') : t('Max Sell Amount'),
    text: "".concat(maxAmount.symbol, " ").concat(maxAmount.formatted),
    customClass: baseClass
  }), /*#__PURE__*/_react["default"].createElement(_APLabelWithText["default"], {
    name: "borrowing",
    label: t('Borrowing'),
    text: "".concat(borrowingAmount.symbol, " ").concat(borrowingAmount.formatted),
    customClass: baseClass
  }), /*#__PURE__*/_react["default"].createElement(_APLabelWithText["default"], {
    name: "hourlyInterest",
    label: t('Hourly Interest'),
    text: "".concat(hourlyInterest.toLocaleString(undefined, {
      maximumFractionDigits: 8
    }), "%"),
    customClass: baseClass
  }));
});
MarginOrderEstimates.displayName = 'MarginOrderEstimates';